<app-dialog-base applyCaption="Yes" [title]="confirmTitle" modalId="actionConfirmModal" [itemTemplate]="confirmActionTemplate" (modalApply)="apply()" (modelCancel)="cancel()"></app-dialog-base>

<ng-template #confirmActionTemplate>
    <div class="sdds-banner">
        <div class="sdds-banner-body">
            {{confirmDesc}}
        </div>
    </div>
</ng-template>